import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
export var BODY_OVERFLOW_STOP_CLASS_NAME = '__body-overflow-stop';
export var InjectGlobalStyle = createGlobalStyle(["", " *{box-sizing:border-box;}body{margin:0;font-family:", ";", ";color:", ";}body.", "{overflow:hidden;}a{color:", ";background-color:transparent;text-decoration:none;outline:none;cursor:pointer;&:hover{text-decoration:underline;}}svg{display:block;line-height:0;}"], normalize, function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.variants.body2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text.base;
}, BODY_OVERFLOW_STOP_CLASS_NAME, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary.base;
});